// GAME ACTION TYPES
export const REMOVE_DUCK = "REMOVE_DUCK"
export const NEW_DUCK = "NEW_DUCK"
